class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(`${this.dataset.url}&intent=complementary`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          // if the response contains elements renders it, else fetch related products
          if (recommendations.querySelector('div, ul, li')) {
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          } else {
            fetch(`${this.dataset.url}&intent=related`)
              .then((response) => response.text())
              .then((relatedText) => {
                const relatedHtml = document.createElement('div');
                relatedHtml.innerHTML = relatedText;
                const relatedRecommendations = relatedHtml.querySelector('product-recommendations');

                if (relatedRecommendations && relatedRecommendations.innerHTML.trim().length) {
                  this.innerHTML = relatedRecommendations.innerHTML;
                }
              })
              .catch((error) => error);
          }
        })
        .catch((err) => err);
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
